import React, { useState } from 'react';
import { PencilIcon, TrashIcon, UserIcon, GlobeAltIcon, ShieldCheckIcon, PhoneIcon, EnvelopeIcon, CalendarIcon } from '@heroicons/react/24/outline';
import Addresses from './Addresses/Addresses';
import { formatBirthDate } from '../../../../utils/dateFormatter';
import { formatEntityPhone, hasPhone } from '../../../../utils/phoneDisplay.utils';

const CustomerDetails = ({ addresses, customer }) => {


  return (
    <div className="space-y-4">
      {/* Section Informations de contact */}
      {(customer.phone || customer.email || customer.birthdate) && (
        <div className="border border-primary/50 rounded-lg p-4 space-y-3">
          <h4 className="text-base-content font-medium">Informations de contact</h4>
          <div className="space-y-2">
            {hasPhone(customer.phone) && (
              <div className="flex items-center space-x-2">
                <PhoneIcon className="w-4 h-4 text-base-content/60 flex-shrink-0" />
                <span className="text-sm text-base-content font-medium">
                  {formatEntityPhone(customer)}
                </span>
              </div>
            )}
            
            {customer.email && (
              <div className="flex items-center space-x-2">
                <EnvelopeIcon className="w-4 h-4 text-base-content/60 flex-shrink-0" />
                <span className="text-sm text-base-content font-medium">
                  {customer.email}
                </span>
              </div>
            )}
            
            {customer.birthdate && (
              <div className="flex items-center space-x-2">
                <CalendarIcon className="w-4 h-4 text-base-content/60 flex-shrink-0" />
                <span className="text-sm text-base-content font-medium">
                  {formatBirthDate(customer.birthdate)}
                </span>
              </div>
            )}
          </div>
        </div>
      )}

      {/* Section Adresse */}
      <Addresses addresses={addresses} />
      
      {/* Section Représentant légal */}
      {addresses && addresses.length > 0 && (addresses[0].legalFirstname || addresses[0].legalLastname) && (
        <div className="border border-primary/50 rounded-lg p-4 space-y-3">
          <h4 className="text-base-content font-medium">
            Représentant légal
          </h4>
          <div className="flex items-center space-x-2">
            <UserIcon className="w-4 h-4 text-base-content/60 flex-shrink-0" />
            <span className="text-sm text-base-content font-medium">
              {addresses[0].legalFirstname} {addresses[0].legalLastname}
            </span>
          </div>
        </div>
      )}
      
      {/* Section Origine de contact */}
      {customer.contactOrigin && (
        <div className="border border-primary/50 rounded-lg p-4 space-y-3">
          <h4 className="text-base-content font-medium">
            Origine de contact
          </h4>
          <p className="text-sm text-base-content">
            {customer.contactOrigin}
          </p>
        </div>
      )}
      
      {/* Section Est thérapeute */}
      {customer.isCustomerTherapist && (
        <div className="border border-primary/50 rounded-lg p-4 space-y-3">
          <h4 className="text-base-content font-medium">
            Est thérapeute
          </h4>
          <p className="text-sm text-base-content">
            {customer.isCustomerTherapist}
          </p>
        </div>
      )}
    </div>
  );
};

export default CustomerDetails;
